import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaValorParcelaProrrogacaoComDesconto = (): TabelaColuna => ({
  Chave: 'ValorParcelaProrrogacaoComDesconto',
  ComOrdenacao: true,
  RenderizarCabecalho: () => (
    <div style={{ width: 250 }}>Valor Parcela Prorrogação Com Desconto</div>
  )
})
